var __TEMP__ = require('./_baseHasIn.js');var baseHasIn = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_hasPath.js');var hasPath = __REQUIRE_DEFAULT__(__TEMP__);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = hasIn;
